import { last } from 'lodash';

export const addTrailingSlash = (string?: string) => {
  if (!string) return null;

  if (last(string.split('')) === '/') return string;

  return `${string}/`;
};
